import React from "react";
import { useAtom } from "jotai";
import { Navigate } from "react-router-dom";

import { tokenAtom } from "../atoms/accountAtom";

const LoginRoute = ({ children }) => {
  const [token] = useAtom(tokenAtom);

  if (token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default LoginRoute;
